export default "__VITE_ASSET__YxbR6ZCK__"